export default {
  inGameState: null,
  derivedState: null,
  inGameData: null,
  features: null,
};
